// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"eeZOc":[function(require,module,exports,__globalThis) {
var _miraCollectionNavigationJs = require("../utils/mira-collection-navigation.js");
class MIRACarousel extends HTMLElement {
    isCollectionCategoryContext() {
        return !!this.closest(this.collectionCategoryContextSelector);
    }
    isCollectionCategoryPage() {
        return !!this.closest(this.collectionCategoryPageSelector);
    }
    connectedCallback() {
        this._onCategoryLinkClick = this.handleCategoryLinkClick.bind(this);
        this.addEventListener(`click`, this._onCategoryLinkClick, true);
        this.initCarousel();
        // Shopify Editor Listeners
        const events = [
            `shopify:section:load`,
            `shopify:block:select`
        ];
        events.forEach((ev)=>this.addEventListener(ev, this.handleEditorBound));
    }
    handleCategoryLinkClick(e) {
        if (!this.isCollectionCategoryContext()) return;
        if (e.defaultPrevented) return;
        const link = e.target.closest(`a.mira-category-card--link`);
        if (!link) return;
        const slide = link.closest(`.mira-category-card__slide`);
        if (!slide) return;
        const groupEl = slide.closest(`mira-tab-group`);
        const panelId = groupEl === null || groupEl === void 0 ? void 0 : groupEl.getAttribute(`data-tab-panel-id`);
        const href = this.getCategoryCardHref(slide);
        if (panelId && href) (0, _miraCollectionNavigationJs.storeShopCategoryTab)(panelId, (0, _miraCollectionNavigationJs.getCollectionHandleFromUrl)(href));
    }
    /**
     * STOPS Manual Video Cards (The ones with sound)
     */ stopAllManualVideos() {
        const playingCards = this.querySelectorAll(`${this.selectors.videoCard}.is-video-playing`);
        playingCards.forEach((card)=>{
            const video = card.querySelector('video');
            if (video) video.pause();
            card.classList.remove('mira-video-playing');
        });
    }
    /**
     * Handle Muted Background PDP Videos (Autoplay)
     */ handlePdpVideos(swiper) {
        // Pause all background pdp videos
        this.querySelectorAll(this.selectors.pdpVideo).forEach((v)=>{
            v.pause();
            v.muted = true;
        });
        // Play only in active slide
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activePdpVideo = activeSlide === null || activeSlide === void 0 ? void 0 : activeSlide.querySelector(this.selectors.pdpVideo);
        if (activePdpVideo) {
            activePdpVideo.muted = true;
            activePdpVideo.play().catch(()=>{});
        }
    }
    initCarousel() {
        // Swiper is loaded as a separate global script. If it hasn't executed yet
        // (load-order race, or it's added late), wait for it instead of throwing
        // a ReferenceError that would kill the whole carousel (and its buttons).
        if (typeof Swiper === 'undefined') {
            if (this._swiperPoll) return;
            let tries = 0;
            this._swiperPoll = setInterval(()=>{
                if (typeof Swiper !== 'undefined') {
                    clearInterval(this._swiperPoll);
                    this._swiperPoll = null;
                    this.initCarousel();
                } else if (++tries > 100) {
                    clearInterval(this._swiperPoll);
                    this._swiperPoll = null;
                    console.warn('mira-carousel: Swiper global was not found; carousel not initialized.');
                }
            }, 50);
            return;
        }
        const self = this;
        const container = this.querySelector(this.selectors.swiperContainer);
        const settingsEl = this.querySelector(this.selectors.settings);
        if (!container || !settingsEl) return;
        const settings = JSON.parse(settingsEl.textContent);
        const categorySlideCount = this.getCollectionCategorySlideCount();
        const isFewCategoryItems = categorySlideCount !== null && categorySlideCount < 3;
        if (isFewCategoryItems) {
            this.classList.add('mira-category-carousel--few-items');
            this.prepareCollectionFewItemsSettings(settings, categorySlideCount);
        } else {
            this.classList.remove('mira-category-carousel--few-items');
            if (this.isCollectionCategoryPage()) this.prepareCollectionDesktopEndSpacers(settings);
        }
        function setVideoProgress(video, progressEl) {
            if (!video || !progressEl) return;
            function update() {
                if (!video.duration) return;
                const percent = video.currentTime / video.duration * 100;
                self.style.setProperty('--progress', percent + '%');
            }
            video.addEventListener('timeupdate', update);
            video.onended = ()=>{
                self.style.setProperty('--progress', '100%');
            };
        }
        const presets = {
            on: {
                init: function() {
                    self.handlePdpVideos(this);
                    const activeSlide = this.slides[this.activeIndex];
                    if (!activeSlide) return;
                    const video = activeSlide.querySelector('.js-video-hero');
                    const progress = self;
                    if (!video) {
                        progress.style.setProperty('--progress', '100%');
                        return;
                    }
                    video.muted = true;
                    video.currentTime = 0;
                    video.play().catch(()=>{});
                    setVideoProgress(video, progress);
                    video.onended = ()=>{
                        if (this.isEnd) this.slideTo(0);
                        else this.slideNext();
                    };
                },
                slideChangeTransitionStart: function() {
                    // REQUIREMENT: As soon as the slide starts moving, kill all manual videos with sound
                    self.stopAllManualVideos();
                    // Update the muted background videos
                    self.handlePdpVideos(this);
                    // Hero Progress Reset
                    self.style.setProperty('--progress', '0%');
                },
                slideChangeTransitionEnd: function() {
                    // Hero Progress Playback Logic
                    const activeSlide = this.slides[this.activeIndex];
                    const hero = activeSlide === null || activeSlide === void 0 ? void 0 : activeSlide.querySelector(self.selectors.heroVideo);
                    if (hero) {
                        hero.muted = true;
                        hero.play().catch(()=>{});
                    } else self.style.setProperty('--progress', '100%');
                },
                slideChange: function() {
                    self.style.setProperty('--progress', '0%');
                    self.querySelectorAll('.js-video-hero').forEach((v)=>{
                        v.pause();
                        v.currentTime = 0;
                        v.onended = null;
                    });
                    const activeSlide = this.slides[this.activeIndex];
                    if (!activeSlide) return;
                    const video = activeSlide.querySelector('.js-video-hero');
                    const progress = self;
                    if (!video) {
                        progress.style.setProperty('--progress', '100%');
                        return;
                    }
                    video.muted = true;
                    video.play().catch(()=>{});
                    setVideoProgress(video, progress);
                    video.onended = ()=>{
                        if (this.isEnd) this.slideTo(0);
                        else this.slideNext();
                    };
                }
            }
        };
        const config = Object.assign({
            navigation: {
                nextEl: this.querySelector(this.selectors.navNext),
                prevEl: this.querySelector(this.selectors.navPrev)
            },
            pagination: {
                el: this.selectors.pagination,
                clickable: true
            }
        }, settings, presets);
        this.swiper = new Swiper(container, config);
        if (this.isCollectionCategoryPage()) this.activateCurrentCollectionCard();
        // Hover/Open logic
        this.querySelectorAll(this.selectors.slides).forEach((slide)=>{
            slide.addEventListener("mouseenter", ()=>slide.classList.add('is-hover'));
            slide.addEventListener("mouseleave", ()=>slide.classList.remove('is-hover'));
            slide.addEventListener("click", (e)=>{
                if (e.target.closest('button') || e.target.closest(this.selectors.videoCard)) return;
                if (this.handleCollectionCardNavigation(e, slide)) return;
                slide.classList.toggle('is-open');
                setTimeout(()=>{
                    var _this_swiper;
                    return (_this_swiper = this.swiper) === null || _this_swiper === void 0 ? void 0 : _this_swiper.update();
                }, 400);
            });
        });
    }
    handleCollectionCardNavigation(e, slide) {
        if (!this.isCollectionCategoryContext()) return false;
        if (this.swiper && this.swiper.allowClick === false) return true;
        const href = this.getCategoryCardHref(slide);
        if (!href) return false;
        const targetUrl = this.resolveCollectionUrl(href);
        if (!targetUrl) return false;
        const groupEl = slide.closest(`mira-tab-group`);
        const panelId = groupEl === null || groupEl === void 0 ? void 0 : groupEl.getAttribute(`data-tab-panel-id`);
        e.preventDefault();
        if (panelId) (0, _miraCollectionNavigationJs.storeShopCategoryTab)(panelId, (0, _miraCollectionNavigationJs.getCollectionHandleFromUrl)(targetUrl));
        window.location.href = targetUrl;
        return true;
    }
    activateCurrentCollectionCard() {
        if (!this.swiper || !this.isCollectionCategoryPage()) return;
        const currentPath = this.normalizeCollectionPath(window.location.pathname);
        if (!currentPath) return;
        const pageHandle = (0, _miraCollectionNavigationJs.getCollectionHandleFromUrl)(currentPath);
        const slides = [
            ...this.querySelectorAll('.mira-category-card__slide:not(.mira-category-card__slide--spacer)')
        ];
        const matchedSlide = slides.find((slide)=>{
            const cardUrl = slide.getAttribute('data-card-url');
            if (!cardUrl) return false;
            const cardPath = this.normalizeCollectionPath(cardUrl);
            if (cardPath === currentPath) return true;
            const cardHandle = (0, _miraCollectionNavigationJs.getCollectionHandleFromUrl)(cardPath);
            return (0, _miraCollectionNavigationJs.collectionHandlesMatch)(pageHandle, cardHandle);
        });
        if (!matchedSlide) return;
        const swiperSlides = [
            ...this.swiper.slides
        ];
        const matchedIndex = swiperSlides.indexOf(matchedSlide);
        if (matchedIndex < 0) return;
        const isFewItems = this.classList.contains(`mira-category-carousel--few-items`);
        const targetIndex = isFewItems ? matchedIndex : window.matchMedia('(min-width: 768px)').matches ? Math.max(matchedIndex - 1, 0) : matchedIndex;
        this.swiper.slideTo(targetIndex, 0);
    }
    getCategoryCardHref(slide) {
        const anchor = slide.querySelector('a.mira-category-card--link');
        if (anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute('href')) return anchor.getAttribute('href');
        return slide.getAttribute('data-card-url');
    }
    resolveCollectionUrl(value) {
        const path = this.normalizeCollectionPath(value);
        if (path) return path;
        try {
            return new URL(value, window.location.origin).href;
        } catch (error) {
            return value;
        }
    }
    normalizeCollectionPath(value) {
        if (!value) return '';
        const normalizedValue = value.trim().replace(/\/$/, '');
        const shopifyCollectionPrefix = 'shopify://collections/';
        if (normalizedValue.startsWith(shopifyCollectionPrefix)) {
            const handle = normalizedValue.slice(shopifyCollectionPrefix.length).split('/').filter(Boolean).pop();
            return handle ? `/collections/${handle}` : '';
        }
        try {
            const url = new URL(normalizedValue, window.location.origin);
            return url.pathname.replace(/\/$/, '');
        } catch (error) {
            return normalizedValue.startsWith('/') ? normalizedValue : '';
        }
    }
    getCollectionCategorySlideCount() {
        if (!this.isCollectionCategoryContext()) return null;
        if (!this.querySelector('.mira-category-card__slide')) return null;
        return this.querySelectorAll('.mira-category-card__slide:not(.mira-category-card__slide--spacer)').length;
    }
    prepareCollectionFewItemsSettings(settings, slideCount) {
        const applyFewItemsBreakpoint = (bp, breakpointKey)=>{
            if (!bp || typeof bp !== 'object') return;
            const slidesPerView = bp.slidesPerView;
            var _bp_spaceBetween, _ref;
            const spaceBetween = (_ref = (_bp_spaceBetween = bp.spaceBetween) !== null && _bp_spaceBetween !== void 0 ? _bp_spaceBetween : settings.spaceBetween) !== null && _ref !== void 0 ? _ref : 0;
            bp.initialSlide = 0;
            bp.centeredSlides = true;
            bp.centeredSlidesBounds = false;
            bp.slideToClickedSlide = true;
            if (typeof slidesPerView === 'number') {
                bp.slidesPerView = 'auto';
                if (breakpointKey === '768') {
                    this.style.setProperty('--mira-category-spv-tablet', String(slidesPerView));
                    this.style.setProperty('--mira-category-slide-gap-tablet', `${spaceBetween}px`);
                }
                if (breakpointKey === '990') {
                    this.style.setProperty('--mira-category-spv-desktop', String(slidesPerView));
                    this.style.setProperty('--mira-category-slide-gap-desktop', `${spaceBetween}px`);
                }
            }
        };
        settings.initialSlide = 0;
        settings.centeredSlides = true;
        settings.centeredSlidesBounds = false;
        settings.slideToClickedSlide = true;
        settings.watchOverflow = false;
        if (typeof settings.slidesPerView === 'number') settings.slidesPerView = 'auto';
        if (settings.breakpoints) Object.entries(settings.breakpoints).forEach(([key, bp])=>applyFewItemsBreakpoint(bp, key));
    }
    prepareCollectionDesktopEndSpacers(settings) {
        var _settings_breakpoints_, _settings_breakpoints;
        const container = this.querySelector(this.selectors.swiperContainer);
        const wrapper = container === null || container === void 0 ? void 0 : container.querySelector('.swiper-wrapper');
        if (!wrapper || !this.isCollectionCategoryPage()) return;
        wrapper.querySelectorAll('.mira-category-card__slide--spacer').forEach((slide)=>slide.remove());
        if (!window.matchMedia('(min-width: 768px)').matches) return;
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const slidesPerView = Number(settings === null || settings === void 0 ? void 0 : (_settings_breakpoints = settings.breakpoints) === null || _settings_breakpoints === void 0 ? void 0 : (_settings_breakpoints_ = _settings_breakpoints[isDesktop ? '990' : '768']) === null || _settings_breakpoints_ === void 0 ? void 0 : _settings_breakpoints_.slidesPerView);
        if (isDesktop && slidesPerView !== 4 || !isDesktop && slidesPerView !== 3) return;
        const realSlides = wrapper.querySelectorAll('.mira-category-card__slide:not(.mira-category-card__slide--spacer)');
        if (realSlides.length < 3 || realSlides.length <= slidesPerView) return;
        const startSpacer = document.createElement('li');
        startSpacer.className = 'mira-category-card__slide mira-category-card__slide--spacer swiper-slide';
        startSpacer.setAttribute('aria-hidden', 'true');
        wrapper.prepend(startSpacer);
        const endSpacerCount = isDesktop ? 2 : 1;
        for(let i = 0; i < endSpacerCount; i += 1){
            const spacer = document.createElement('li');
            spacer.className = 'mira-category-card__slide mira-category-card__slide--spacer swiper-slide';
            spacer.setAttribute('aria-hidden', 'true');
            wrapper.appendChild(spacer);
        }
    }
    handleEditorEvent(e) {
        if (e.type === 'shopify:section:load') this.initCarousel();
        if (e.type === 'shopify:block:select' && this.swiper) {
            const el = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
            const slide = el === null || el === void 0 ? void 0 : el.closest(this.selectors.slides);
            if (slide) {
                const idx = [
                    ...this.querySelectorAll(this.selectors.slides)
                ].indexOf(slide);
                this.swiper.slideTo(idx);
            }
        }
    }
    constructor(){
        super();
        this.debug = false;
        this.swiper = null;
        this.selectors = {
            pdpVideo: '.js-mira-pdp-video',
            heroVideo: '.js-video-hero',
            videoCard: 'mira-video-card',
            swiperContainer: '.swiper',
            settings: '#swiper-settings',
            slides: '.swiper-slide',
            navNext: '.mira-carousel-button-next',
            navPrev: '.mira-carousel-button-prev',
            pagination: '.swiper-pagination'
        };
        this.handleEditorBound = this.handleEditorEvent.bind(this);
        this.collectionCategoryContextSelector = '#collection-category-products, .mira-collection-categories';
        this.collectionCategoryPageSelector = '#collection-category-products';
    }
}
if (!customElements.get('mira-carousel')) customElements.define('mira-carousel', MIRACarousel);

},{"../utils/mira-collection-navigation.js":"cuP4R"}],"cuP4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MIRA_SHOP_CATEGORY_TAB_KEY", ()=>MIRA_SHOP_CATEGORY_TAB_KEY);
parcelHelpers.export(exports, "MIRA_SHOP_CATEGORY_HANDLE_KEY", ()=>MIRA_SHOP_CATEGORY_HANDLE_KEY);
parcelHelpers.export(exports, "getCollectionHandleFromUrl", ()=>getCollectionHandleFromUrl);
parcelHelpers.export(exports, "collectionHandlesMatch", ()=>collectionHandlesMatch);
parcelHelpers.export(exports, "storeShopCategoryTab", ()=>storeShopCategoryTab);
parcelHelpers.export(exports, "consumeShopCategoryTab", ()=>consumeShopCategoryTab);
const MIRA_SHOP_CATEGORY_TAB_KEY = `mira_shop_category_tab`;
const MIRA_SHOP_CATEGORY_HANDLE_KEY = `mira_shop_category_handle`;
function getCollectionHandleFromUrl(url) {
    if (!url) return null;
    const match = String(url).match(/\/collections\/([^/?#]+)/);
    return (match === null || match === void 0 ? void 0 : match[1]) || null;
}
function collectionHandlesMatch(pageHandle, linkHandle) {
    return !!pageHandle && pageHandle === linkHandle;
}
function storeShopCategoryTab(panelId, collectionHandle) {
    if (!panelId) return;
    sessionStorage.setItem(MIRA_SHOP_CATEGORY_TAB_KEY, panelId);
    if (collectionHandle) sessionStorage.setItem(MIRA_SHOP_CATEGORY_HANDLE_KEY, collectionHandle);
}
function consumeShopCategoryTab() {
    const panelId = sessionStorage.getItem(MIRA_SHOP_CATEGORY_TAB_KEY);
    if (!panelId) return null;
    sessionStorage.removeItem(MIRA_SHOP_CATEGORY_TAB_KEY);
    sessionStorage.removeItem(MIRA_SHOP_CATEGORY_HANDLE_KEY);
    return panelId;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"e7DJg"}],"e7DJg":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["eeZOc"], "eeZOc", "parcelRequiree28a", {})

//# sourceMappingURL=mira-carousel.js.map
